import { Modal } from '../../../modal/Modal';
import { BusinessOwner, BusinessOwnerProps } from './BusinessOwner';

type Props = {
    visible: boolean;
    onCloseModal: () => void;
} & Omit<BusinessOwnerProps, 'onClose'>;

export const UpdateBusinessModal: React.FC<Props> = ({ visible, onCloseModal, ...rest }) => {
    if (!visible) return null;

    return (
        <Modal
            title="Beneficial Owner Information"
            className="UpdateBusinessModal"
            closeOnClickOutside={false}
            onCloseModal={onCloseModal}
        >
            <BusinessOwner {...rest} onClose={onCloseModal} />
        </Modal>
    );
};
